import { useMultiuserContext } from "@solidwhite/multiuser";
import { useEffect } from "react";
import { useSnapshot } from "valtio";
import store from "../../appStore";

const PresentatorAwarenessSender = ({ ...props }) => {
  const { awareness, presenting } = useMultiuserContext();
  const { currentUser } = useSnapshot(store);

  useEffect(() => {
    awareness.setLocalStateField("name", currentUser.signInDetails.loginId.split("@")[0]);
    awareness.setLocalStateField("color", "#37a46e");
  }, [presenting]);

  return null;
};

export default PresentatorAwarenessSender;
